import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map();

const apply = (title, description) => {
  if (title) document.title = title;
  const meta = document.querySelector('meta[name="description"]');
  if (meta && description) meta.setAttribute("content", description);
};

// Title/description come from the `seo_pages` collection (same source as the server-injected head); props are the fallback.
export const PageMeta = ({ title, description }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    let active = true;
    const fallback = () => apply(title ? `${title} | Entertainment Nation` : "Entertainment Nation", description);
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const hit = cache.get(path);
    if (hit) return apply(hit.title, hit.description);
    fetch(`${API}/seo/pages${path}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((seo) => {
        if (!active) return;
        if (seo) { cache.set(path, seo); apply(seo.title, seo.description); } else fallback();
      })
      .catch(() => active && fallback());
    return () => { active = false; };
  }, [pathname, title, description]);
  return null;
};
